import React from 'react';
import { Input, RequiredHelpPhrase, Row, UrlParam } from '../../../../../_lib/Form2';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';

type ExternalContentFormTemplateProperties = {
  urlParam: UrlParam<'url'>;
};

function cspToRegEx(csp: string) {
  const cspRegEx = csp.replace('.', '\\.').replace('*', '.*');
  return new RegExp(cspRegEx);
}

function whiteListIncludes(allowList: string[], url: string) {
  return allowList.map(cspToRegEx).some(re => re.test(url));
}

export function ExternalContentFormTemplate({ urlParam }: ExternalContentFormTemplateProperties) {
  const { t } = useSonTranslation('PageManagement');

  const validate = (cspAllowList: string[] | undefined, url: string) => {
    try {
      new URL(url);
    } catch {
      return t(`views.create-page-general.inputs.externalcontent.inputMalformed`);
    }
    if (cspAllowList && whiteListIncludes(cspAllowList, url)) {
      return '';
    }
    return t(`views.create-page-general.inputs.externalcontent.CSPnotAllowed`);
  };

  return (
    <>
      <RequiredHelpPhrase />
      <Row>
        <Input
          label={t('views.create-page-general.inputs.externalcontent.labelTitle')}
          helpText={t('views.create-page-general.inputs.externalcontent.labelHelpText')}
          param={urlParam}
          onChange={(event) => {
            if (event.target.value) {
              event.target.setCustomValidity(validate(urlParam.constraints?.domainAllowlist, event.target.value));
            }
          }}
        />
      </Row>
    </>
  );
}
